import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
import './styles/main.css'

createApp(App)
  .use(router)
  .use(i18n)
  .use(vuetify)
  .mount('#app')
